import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { spacing, srOnly } from '@vfuk/core-mixins'

import type { StyledImagePickerProps } from './ImagePicker.style.types'

export const ImageWrapper = styled.span<StyledImagePickerProps>((props: StyledImagePickerProps): FlattenSimpleInterpolation => {
  const { imgBorderRadius } = props.inverse
    ? props.imagePickerTheme.appearance[props.appearance].inverse
    : props.imagePickerTheme.appearance[props.appearance]

  return css`
    display: flex;
    ${spacing('padding', 1)};
    ${spacing('margin-right', 2)};

    & img {
      border-radius: ${imgBorderRadius};
      min-width: 52px;
      min-height: 52px;
    }
  `
})

export const Legend = styled.legend(
  (): FlattenSimpleInterpolation => css`
    ${srOnly()}
  `,
)

export const PickerItemWrapper = styled.span((): FlattenSimpleInterpolation => [])

export const Fieldset = styled.fieldset((): FlattenSimpleInterpolation => [])
